// Links of Claude's answers into the pipeline (deal:, mail:, anhang:, firma:, anfrage:, dok:), see markdown.ts.
import { S } from "../state";
import { toast } from "../util";
import { openDocument } from "./document";
import { downloadAttachment, showOriginal } from "./original";
import { openInquiry } from "./search";

const go = (hash: string) => {
  if (location.hash === hash) dispatchEvent(new HashChangeEvent("hashchange"));
  else location.hash = hash;
};

/** `label`: the link text; for an attachment it is the file name to save under. */
export async function openPipelineLink(link: string, label?: string): Promise<void> {
  const i = link.indexOf(":");
  const scheme = link.slice(0, i).toLowerCase();
  const target = link.slice(i + 1).trim();
  if (scheme === "deal") {
    // Open deals are loaded; a closed one is found through the search.
    const ref = target.toUpperCase();
    const known = [...S.deals.values()].find((d) => d.ref === ref);
    const id = known?.id ?? (await S.api.search(ref).catch(() => null))?.deals.find((d) => d.ref === ref)?.id;
    if (id) go(`#deal-${id}`);
    else toast(`Den Deal ${ref} gibt es nicht.`);
  } else if (scheme === "mail") void showOriginal(target);
  else if (scheme === "anhang") void downloadAttachment(target, label?.trim() || "Anhang");
  else if (scheme === "firma") go(`#firma-${target}`);
  else if (scheme === "anfrage") openInquiry(target, false);
  else if (scheme === "dok") void openDocument(target);
}
